<template>
  <form class="form">
    <FormSelect :label="$t('form.label.emplacement')" name="category_id" :options="subCategoriesOptions"
      v-model="form.fields.category_id" required />
    <FormInput :label="$t('form.label.document.title')" v-model="form.fields.title" name="title" required />
    <FormSelect :label="$t('form.label.document.type')" name="type" :options="urlOrFileOptions"
      v-model="form.fields.urlFile" required />
    <FormInput v-if="form.fields.urlFile.value === 'url'" :label="$t('form.label.url')" type="url"
      v-model="form.fields.url" name="url" :message="$t('form.messages.url')" required />
    <FormFile v-if="form.fields.urlFile.value === 'file'" :label="$t('form.label.file')" v-model="form.fields.file"
      name="file" :maxSize="5000" :message="$t('form.messages.5mb_pdf')" required />
  </form>
</template>

<script>
import { FormFile, FormInput, FormSelect } from '@/components/form/fields'
import FormValidMixin from '@/components/form/mixins/FormValidMixin.js'

export default {
  name: 'AddEditDocument',
  mixins: [FormValidMixin],
  components: {
    FormInput,
    FormFile,
    FormSelect,
  },
  data() {
    return {
      form: {
        fields: {
          category_id: {
            value: null,
            valid: false
          },
          title: {
            value: '',
            valid: false
          },
          urlFile: {
            value: 'url',
            valid: false
          },
          url: {
            value: null,
            valid: false
          },
          file: {
            file: '',
            previewName: null,
            previewUrl: null,
            value: '',
            valid: false
          },
        },
        submitted: false
      },
    }
  },
  computed: {
    urlOrFileOptions() {
      return [
        { key: 'url', value: this.$t('form.label.file_url.url') },
        { key: 'file', value: this.$t('form.label.file_url.file') }
      ] 
    },
    subCategoriesOptions() {
      return Array.from(this.$category.sub_categories)
        .map(sub_category => {
          const category = Array.from(this.$category.all).find(({ id }) => id.toString() === sub_category.parent_id.toString())

          return {
            key: sub_category.id,
            value: `${category.title} - ${sub_category.title}`
          }
        })
        .sort((a, b) => a.key - b.key)
    }
  },
  watch: {
    'form.fields.urlFile': {
      handler() {
        if (this.form.fields.urlFile.value === 'url') {
          this.form.fields.file.valid = true
        }
        if (this.form.fields.urlFile.value === 'file') {
          this.form.fields.url.valid = true
        }
      },
      immediate: true
    }
  },
  methods: {
    messageToTooltip() {
      const title = this.form.fields.title.value

      if (this.$route.query.action === this.$query.ACTION.EDIT) {
        return this.$popup.report(`${title} ${this.$t('popup.modifiedElement')}`, false)
      }

      this.$popup.report(`${title} ${this.$t('popup.createdElement')}`, false)
    },
    async submit() {
      if (this.form.valid) {
        this.form.submitted = true

        const formData = {
          category_id: this.form.fields.category_id.value,
          title: this.form.fields.title.value,
          url: this.form.fields.urlFile.value === 'url' ? this.form.fields.url.value : null,
        }

        let currentId
        this.$route.query.action === this.$query.ACTION.EDIT
          ? currentId = await this.$document.update(this.$route.query.id, formData)
          : currentId = await this.$document.store(formData)

        if (this.form.fields.file.file) {
          await this.$document.uploadFile(currentId, this.form.fields.file.file[0])
        }

        this.form.submitted = false

        this.messageToTooltip()
      }
    }
  },
  mounted() {
    if (this.$route.params.subCategoryId) {
      this.form.fields.category_id = {valid: true, value: this.$route.params.subCategoryId}    
    }

    if (this.$route.query.action === this.$query.ACTION.EDIT && this.$document.all && this.$category.sub_categories) {
      const document = Array.from(this.$document.all).find(({ id }) => id.toString() === this.$route.query.id.toString())

      this.form.fields.title = { valid: true, value: document.title }
      this.form.fields.category_id = { valid: true, value: this.$route.params.subCategoryId }

      if (document.url) {
        this.form.fields.url = { valid: true, value: document.url }
        this.form.fields.urlFile = { valid: true, value: 'url' }
      } else {
        this.form.fields.urlFile = { valid: true, value: 'file' }
        this.form.fields.file.previewName = document.file?.name ?? null
      }
    }
  }
}
</script>